/* eslint-disable no-underscore-dangle */
// Make sure the global stylesheet is added to the gatsby build.
import { WIDGET_DESTINATION_PATHS } from './src/constants';
import './src/styles/import-tailwind-css';
import appInsights from './src/utils/applicationinsights';
import {
  FEATURE_INVOICE,
  FEATURE_SHAREPOINT,
  isEnabled,
} from './src/utils/features';
import { getBIReports } from './src/utils/getBIReports';
import { getClubInvoiceReport } from './src/utils/getClubInvoiceReport';
import { getDistrictViewInvoiceReport } from './src/utils/getDistrictViewInvoiceReport';
import { getDailyClubBalanceReport } from './src/utils/getDailyClubBalanceReport';
import { getDailyDistrictBalanceReport } from './src/utils/getDailyDistrictBalanceReport';
import { getDestinationPath } from './src/utils/getDestinationPath';
import { parseUrl } from './src/utils/parseUrl';
import { waitForDonateWidget } from './src/utils/waitForDonateWidget';

// Export the central `wrapRootElement` function.
export { wrapRootElement } from './src/utils/wrap-root-element';

// Init and track page view in Azure App Insights.
// if (appInsights.config.instrumentationKey) {
appInsights.loadAppInsights();
appInsights.trackPageView();
// }

const scrollTo = id => {
  // eslint-disable-next-line consistent-return
  const intervalId = setInterval(() => {
    const el = document.querySelector(id);
    if (el) {
      clearInterval(intervalId);
      return window.scrollTo(0, el.getBoundingClientRect().top);
    }
  }, 500);
};

export const onRouteUpdate = ({
  location: { hash, pathname },
  prevLocation,
}) => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('gatsby-route-update'));
    if (
      pathname.includes('view-club-balance-report') &&
      !pathname.includes('domui')
    ) {
      const isInvoiceEnabled = isEnabled(FEATURE_INVOICE);
      if (isInvoiceEnabled) {
        const pathSegments = pathname.split('/').filter(segment => segment);
        const basePathIndex = pathSegments.indexOf('view-club-balance-report');
        if (basePathIndex !== -1 && pathSegments.length - basePathIndex === 1) {
          const districtId = pathSegments[basePathIndex - 1];
          getDailyDistrictBalanceReport(districtId);
          return;
        }
      }
    }
    if (
      pathname.includes('daily-club-balance-report') &&
      !pathname.includes('domui/daily-club-balance-report')
    ) {
      const isInvoiceEnabled = isEnabled(FEATURE_INVOICE);
      if (isInvoiceEnabled) {
        const pathSegments = pathname.split('/').filter(segment => segment);
        const basePathIndex = pathSegments.indexOf('daily-club-balance-report');

        if (
          basePathIndex !== -1 &&
          pathSegments.length - basePathIndex - 1 === 1
        ) {
          const clubId = pathSegments[basePathIndex + 1];
          getDailyClubBalanceReport(clubId);
          return;
        }
      }
    }

    if (
      pathname.includes('view-club-invoice-report') &&
      !pathname.includes('domui/view-club-invoice-report')
    ) {
      const isInvoiceEnabled = isEnabled(FEATURE_INVOICE);
      if (isInvoiceEnabled) {
        const pathSegments = pathname.split('/').filter(segment => segment);
        const basePathIndex = pathSegments.indexOf('view-club-invoice-report');

        if (
          basePathIndex !== -1 &&
          pathSegments.length - basePathIndex - 1 === 1
        ) {
          const clubId = pathSegments[basePathIndex + 1];
          getDistrictViewInvoiceReport(clubId);
          return;
        }
      }
    }

    if (
      pathname.includes('club-invoice-report') &&
      !pathname.includes('domui/club-invoice-report')
    ) {
      const isInvoiceEnabled = isEnabled(FEATURE_INVOICE);
      if (isInvoiceEnabled) {
        const pathSegments = pathname.split('/').filter(segment => segment);
        const basePathIndex = pathSegments.indexOf('club-invoice-report');

        if (
          basePathIndex !== -1 &&
          pathSegments.length - basePathIndex - 1 === 1
        ) {
          const clubId = pathSegments[basePathIndex + 1];
          getClubInvoiceReport(clubId);
          return;
        }
      }
    }

    if (pathname.includes('club-and-district-reports')) {
      const isSharepointEnabled = isEnabled(FEATURE_SHAREPOINT);

      if (isSharepointEnabled) {
        const { subPaths, params } = parseUrl(window.location.href);

        const basePathIndex = subPaths.indexOf('club-and-district-reports');

        if (basePathIndex !== -1) {
          const oktaId = subPaths[2];
          const reportTechnicalName = subPaths[3];
          const dataSelector = subPaths[4];
          const language = subPaths[0];

          const queryParamKeys = ['clubId', 'districtId'];

          const queryParams = {};

          queryParamKeys.forEach(key => {
            if (params[key]) {
              queryParams[key] = params[key];
            }
          });

          getBIReports(
            oktaId,
            reportTechnicalName,
            dataSelector,
            queryParams,
            language
          );
          return;
        }
      }
    }

    if (hash && pathname !== prevLocation?.pathname) scrollTo(hash);

    // Load donateWidget on browser navigating
    const { isDesiredPath: isWidgetDestination } = getDestinationPath(
      WIDGET_DESTINATION_PATHS
    );

    if (isWidgetDestination) {
      const container = document.getElementById('donate-widget');
      // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-underscore-dangle
      if (!window._donateWidgetInitialized || !container) {
        const retryInterval = setInterval(() => {
          const containerCheck = document.getElementById('donate-widget');
          if (containerCheck) {
            window._donateWidgetInitialized = true;
            waitForDonateWidget('#wrapper-id', 500, 5000);
            clearInterval(retryInterval);
          }
        }, 200); // check every 200ms
        setTimeout(() => clearInterval(retryInterval), 15000); // stop retry after 15s
      }
    }
  }
};
